const aidBase = 28761;

const maxAid = Math.ceil(0.58 * aidBase);

const dismissalTypeTrans = [0, 1, 1, 2, 1, 2, 3];

export function getAidDuration(age) {
	if (age < 50) {
		return 5;
	} else if (age < 55) {
		return 8;
	}
	return 11;
}

export function getFirstPhaseAid(income, dismissalType) {
	switch (dismissalType) {
		case 1:
			return Math.min(Math.ceil(income * 0.65), maxAid);

		case 2:
			return Math.min(Math.ceil(income * 0.45), maxAid);

		case 3:
			return 0;
	}
}

export function getSecondPhaseAid(income, dismissalType) {
	switch (dismissalType) {
		case 1:
			return Math.min(Math.ceil(income * 0.5), maxAid);

		case 2:
			return Math.min(Math.ceil(income * 0.45), maxAid);

		case 3:
			return 0;
	}
}

export function getLastPhaseAid(income, dismissalType) {
	switch (dismissalType) {
		case 1:
		case 2:
			return Math.min(Math.ceil(income * 0.45), maxAid);

		case 3:
			return 0;
	}
}

export default ({ income, dismissalType, age }) => {
	const dismissalTypeTranslated = dismissalTypeTrans[dismissalType];

	const duration = getAidDuration(age);
	const firstPhaseAid = getFirstPhaseAid(income, dismissalTypeTranslated);
	const secondPhaseAid = getSecondPhaseAid(income, dismissalTypeTranslated);
	const lastPhaseAid = getLastPhaseAid(income, dismissalTypeTranslated);

	return {
		duration: duration,
		aid: {
			firstPhase: firstPhaseAid,
			secondPhase: secondPhaseAid,
			lastPhase: lastPhaseAid,
		},
	};
};
